import * as React from 'react';

const SvgSendover = props => {
  const { size, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <g>
        <path d="M12.56 13.71H3.85a.75.75 0 000 1.5h8.71a.75.75 0 100-1.5zM11.25 18.16h-7.4a.75.75 0 100 1.5h7.4a.75.75 0 000-1.5z" />
        <rect x={3.4} y={3.49} width={5.97} height={6.72} rx={1.04} />
        <path d="M24 15.64a3.66 3.66 0 00-7.32 0v3.13h1.66l.43 5.23h3.14l.43-5.23H24z" />
        <circle cx={20.34} cy={7.56} r={2.88} />
        <path d="M17.14 22.46H1.84a.27.27 0 01-.27-.26V1.81a.27.27 0 01.27-.26h20.63v2.19A4.37 4.37 0 0124 5.11V.8a.75.75 0 00-.75-.75H1.84A1.76 1.76 0 00.07 1.81V22.2A1.76 1.76 0 001.84 24h15.42z" />
      </g>
    </svg>
  );
};

export default SvgSendover;
